import { useContext, useEffect, useState } from 'react';
import { autorun } from 'mobx';
import RootStoreContext from '../../../model/RootStoreContext';
import { ISelection } from '../../../model/selections/Selection';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useSelectionsResult {
    isLoaded: boolean;
    selections: ISelection[];
}

export const useSelections = (archived: boolean, refreshFlag: boolean) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useSelectionsResult>({ isLoaded: false, selections: [] });

    useEffect(() => {
        autorun(() => {
            setResult({ isLoaded: false, selections: [] });

            rootStore.selectionStore.loadSelections(archived)
                .then(() => {
                    setResult({ isLoaded: true, selections: rootStore.selectionStore.selections });
                })
                .catch(e => publishNotification({
                    text: 'Error loading selections',
                    canClose: true
                }));
        });
    }, [rootStore.selectionStore, publishNotification, rootStore.gameVersionStore.currentGameVersion, archived, refreshFlag]);

    return result;
};
